<div #reviewField *ngIf="visible">
    <ng-container *ngIf="!isEditing">
        <cv-review-fields-display
            [fieldOptions]="options"
            [field]="field"
            [value]="value"
            [historical]="historical"
            [show]="show"
            [active]="active"
            (openHistorical)="showHistorical($event)">
        </cv-review-fields-display>
    </ng-container>

    <ng-container *ngIf="isEditing">
        <cv-review-fields-input 
            [fieldOptions]="options"
            [control]="formControl"
            [field]="field"
            [historical]="historical"
            [show]="show"
            [active]="active"
            (openHistorical)="showHistorical($event)">
        </cv-review-fields-input>
    </ng-container>
</div>